module.exports = __webpack_public_path__ + "img/app-icon-oxygen-calculator-512.webp";